// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"175":"af9c3ae6","386":"92416c6a","737":"dd101036","1263":"9b9ac0b8","2554":"18c38726","9254":"9b9ac0b8","9936":"d8866af8"}[chunkId] + ".chunk.css";
};